export const howPaulaCanHelpBtn = 'how-paula-can-help';

export const PaulaErrorMessage = `😔 **I’m sorry!** I am here to assist you with any questions you have regarding companies, **target accounts, website visitors, ICP,** and **intent**. How may I help you with these topics today? <br/><br/>**[See how can I help you 👇](${howPaulaCanHelpBtn})**`;

export const howPaulaCanHelpMessage = `
**How can I help you!** <br/>
- I can provide insights on the **accounts on your target profiles.**
- I can analyse your **website visitors** based on the enriched attributes.
`;
